import { useEffect, useState } from "react";
import { runInAction } from "mobx";
import { Observer } from "mobx-react";
import Head from "next/head";

import { ProgressBar } from "components/UI";

import { useApp } from "stores/app/context";
import translationStore from "stores/translation-store";

export default function UploadProgress(props)
{
  const { legacyUpload: upload } = useApp();
  const [percentage, setPercentage] = useState(upload.progress.percentage);

  useEffect(() =>
  {
    upload.onProgress(() =>
    {
      runInAction(() =>
      {
        setPercentage(upload.progress.percentage);
      });
    });

    return () =>
    {
      upload.onProgress(null);
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Observer>
    {
      () => (
        <>
          <Head>
            <title>{Math.round(percentage)}% - {translationStore.translate("myalbums.add.title")}</title>
          </Head>
          <div className="title">
            {
              upload.state === upload.STATE_IN_PROGRESS ?
              translationStore.translate("myalbums.add.progress.in-progress", {count: upload.files.size}) :
              translationStore.translate("myalbums.add.progress.processing", {count: upload.files.size})
            }
          </div>
          <ProgressBar indeterminate={(upload.state === upload.STATE_PROCESSING)} percentage={percentage} onCancel={props.onCancel} />

          <style jsx>{`
            .title {
              margin-bottom: 10px;
              min-width: 40rem;
            }
          `}</style>
        </>
      )
    }
    </Observer>
  );
}